import styled from "styled-components";

export const Container = styled.div<{ $isdarkmode: boolean }>`
  display: flex;
  padding: min(4rem, 8%);
  background: ${($isdarkmode) => (!$isdarkmode ? 'var(--gray-darkest)' : 'var(--color-white)')};
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  gap: 3rem;
  border-radius: 8px;

  @media (max-width: 64rem) {
    flex-direction: column-reverse;
    align-items: start;
    flex-wrap: wrap;
    background: ${($isdarkmode) => ($isdarkmode ? 'var(--gray-darkest)' : 'var(--color-white)')};
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  padding-right: 3rem;

  @media (max-width: 64rem) {
    padding: 0;
    text-align: center;
    margin-bottom: 2rem;
  }
`;

export const Heading = styled.h3<{ $isdarkmode: boolean }>`
  margin-bottom: 1rem;
  text-align: left;
  color: ${($isdarkmode) => ($isdarkmode ? 'var(--gray-darkest)' : 'var(--color-white)')};
  @media (max-width: 64rem) {
    color: var(--color-black);
  }
`;

export const Text = styled.p<{ $isdarkmode: boolean }>`
  line-height: 1.5;
  max-width: 31.25rem;
  color: ${($isdarkmode) => ($isdarkmode ? 'var(--color-black)' : 'var(--color-white)')};
  @media (max-width: 64rem) {
    text-align: left;
    color: var(--color-black);
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  text-align: right;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 64rem) {
    text-align: center;
  }
`;
